// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39FKi","footer":"styles_footer__3TWFM"};